export enum RegistrationSource{
    OnBoarding = 'Onboarding',
    Register = 'Register',
    AfterRegister = 'AfterRegister'
}